export { NileNavTabPanel } from './nile-nav-tab-panel';